import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { T as Text } from '../Text/Text-Ce2yOjWM.js';

const StyledText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40025937__sc-g0mwes-0"
})(["padding-block-start:", ";padding-block-end:", ";margin-inline-start:", ";margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.none.default, ({
  theme
}) => theme.spacing.none.default, ({
  theme
}) => theme.spacing.xxxsmall.default, ({
  theme
}) => theme.spacing.xxxsmall.default);
const Line = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-g0mwes-1"
})(["height:", ";background-color:", ";flex:1;"], ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.border.color.subtle.default);
const Separator = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-g0mwes-2"
})(["display:flex;flex-direction:row;align-items:center;margin-block-start:", ";margin-block-end:", ";padding-block-start:", ";padding-block-end:", ";height:0;overflow:visible;width:100%;"], ({
  theme,
  $marginBlockStart
}) => theme.spacing[$marginBlockStart].default, ({
  theme,
  $marginBlockEnd
}) => theme.spacing[$marginBlockEnd].default, ({
  theme,
  $paddingBlockStart
}) => theme.spacing[$paddingBlockStart].default, ({
  theme,
  $paddingBlockEnd
}) => theme.spacing[$paddingBlockEnd].default);
const Divider = ({
  text,
  marginBlockStart = 'base',
  marginBlockEnd = 'base',
  paddingBlockStart = 'none',
  paddingBlockEnd = 'none',
  ...restProps
}) => /*#__PURE__*/React__default.createElement(Separator, _extends({}, restProps, {
  $marginBlockStart: marginBlockStart,
  $marginBlockEnd: marginBlockEnd,
  $paddingBlockStart: paddingBlockStart,
  $paddingBlockEnd: paddingBlockEnd,
  role: "separator"
}), text ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line, null), /*#__PURE__*/React__default.createElement(StyledText, {
  renderAs: "span",
  color: "tertiary"
}, text), /*#__PURE__*/React__default.createElement(Line, null)) : /*#__PURE__*/React__default.createElement(Line, null));

export { Divider as D };
//# sourceMappingURL=Divider-CeKwSczh.js.map
